export const environment = {
    appVersion: require('../../package.json').version,
    production: true,
    devel: false,
    serviceWorker: false,
    swaggerUrl: '/v2/api-docs',
    apiUrl: '/api',
    managementUrl: '/management',
};
